import { render, staticRenderFns } from "./AddFunds.vue?vue&type=template&id=70e66596&scoped=true&"
import script from "./AddFunds.vue?vue&type=script&lang=js&"
export * from "./AddFunds.vue?vue&type=script&lang=js&"
import style0 from "./AddFunds.vue?vue&type=style&index=0&id=70e66596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e66596",
  null
  
)

export default component.exports